<section
  #section
  tabindex="0"
  class="conv-dialogue-input"
  data-omni-qa="conv-input-section"
  (keydown.enter)="textareaFocus()"
>
  <form
    novalidate
    (ngSubmit)="handleSubmit()"
    [class]="shouldEnablePreChatWelcome ? 'changeColor' : ''"
  >
    <textarea
      [formControl]="formControl"
      [attr.placeholder]="placeholder"
      (keyup)="onChange($event.key === 'Enter')"
      (paste)="changeAfterDomUpdate()"
      (cut)="changeAfterDomUpdate()"
      #textarea
      data-omni-qa="conv-input-text"
      role="textbox"
      rows="1"
      tabindex="0"
      wrap="hard"
      aria-label="Enter Text"
    >
    </textarea>
    <button
      #submit
      type="submit"
      [disabled]="
        formControl.pristine || formControl.disabled || formControl.invalid
      "
      aria-label="Send message"
      data-omni-qa="conv-input-send"
      [class]="shouldEnablePreChatWelcome ? 'changefontColor' : ''"
    >
      {{ submitButtonCopy }}
    </button>
  </form>
</section>
